import '../css/test.css';
const TestDoneView = ({onKthMail, onGender, onAge, onOccupation, onGDPR, onSubmit}) =>
    /** Start page with login and sign up*/
    <div className="wrapper">
        <h2>Finished</h2>
            <form>
            <div className = "kthMail">
                <label>KTH-Mail (if you are a PROINT-student): </label>
                <input type="text" onChange={(event) => onKthMail(event.target.value)}></input>
            </div>
            <div className = "gender"><label>Gender: </label>
                <input type="radio" value="Male" onChange={e => onGender("male")} name="gender" /> Male
                <input type="radio" value="Female" onChange={e => onGender("female")} name="gender" /> Female
                <input type="radio" value="Other" onChange={e => onGender("other")} name="gender" /> Other
            </div>
            <div className = "age">
            <label>Birthdate (YYYYMMDD): </label>
            <input type="text" onChange={(event) => onAge(event.target.value)}></input>
            </div>
            <div className = "occupation">
            <label>Occupation (e.g. Engineering student): </label>
            <input type="text" onChange={(event) => onOccupation(event.target.value)}></input>
            </div>

            <div className = "GDPR">
            <label>Consent GDPR: </label>
            <input type="radio" value="Yes" onChange={e => onGDPR("yes")} name="GDPR" /> Yes
            </div>
            </form>
            <button onClick={() => onSubmit()}>Submit</button>

    </div>;

export {TestDoneView};
